import React from 'react'
import { Typography,Link } from '@material-ui/core'
import './votingDirectory.scss'

const Directory = ['President', "Vice-President", 'General Secretary', 'Assistant General Secretary','Treasurer','CODEH Chairman','Sports Secretary', "Public Relations Officer", 'Special Duties Officer']

const ExecDirectory = ({ user }) => {
    return (
        // <Typography style={{marginTop:"35vh", textAlign:"center"}}>Voting Has Closed</Typography>
        <div className='voting-directory' style={{marginBottom: "3%"}}> 
            <Typography style={{fontSize:"20px", marginTop:"3%",marginBottom:"2%"}} >  Please Select Office </Typography>
        <div className='directory'>
            {Directory.map(position=>(
                <div key={position} className='item'>
                <Typography style={{paddingTop:"15px"}} >
                   <Link  underline="none" color="inherit" href={`/executives/${position}/${user._id}`}>{position}</Link> 
                </Typography>
                </div>
            ))}
        </div>
        </div>
    )
}

export default ExecDirectory
